import { gql } from '@apollo/client'
import { InventoryType } from '../../domains/ProductPurchaseInfo'

const query = gql`
  query ShopifyProduct($id: ID!) {
    node(id: $id) {
      ... on Product {
        title
        variants(first: 250) {
          edges {
            node {
              id
              quantityAvailable
              priceV2 {
                amount
              }
              inventoryType: metafield(namespace: "inventory", key: "INVENTORY_TYPE_NEW") {
                value
              }
              preOrderShippingDate: metafield(namespace: "inventory", key: "PRE_ORDER_SHIPPING_DATE_NEW") {
                value
              }
              inventoryTypeLowerCase: metafield(namespace: "inventory", key: "inventory_type") {
                value
              }
              preOrderShippingDateLowerCase: metafield(namespace: "inventory", key: "pre_order_shipping_date") {
                value
              }
            }
          }
        }
      }
    }
  }
`

/**
 * https://help.shopify.com/en/api/storefront-api/reference/queryroot
 */
const queryVariantsByProductId = (client: any, variables: { id?: string }): Promise<Variants> =>
  client.query({ query, variables })

export interface Variants {
  data: {
    node: {
      id: string
      variants: {
        edges: VariantEdge[]
      }
    }
  }
}

export interface ShopifyVariantMetaField {
  inventoryType?: {
    value: InventoryType
  }
  preOrderShippingDate?: {
    value: string
  }
  inventoryTypeLowerCase?: {
    value: InventoryType
  }
  preOrderShippingDateLowerCase?: {
    value: string
  }
}

export interface VariantEdge {
  node: {
    id: string
    quantityAvailable: number
    priceV2: {
      amount: string
    }
  } & ShopifyVariantMetaField
}

export default queryVariantsByProductId
